import React from 'react'
import { Grid } from '@material-ui/core'
import { components, constants, useTranslation } from 'cng-web-lib'
import { useState } from 'react'
import CommonConfigKeys from 'src/constants/locale/key/CommonConfig'
import Namespace from 'src/constants/locale/Namespace'
import CommonConfigAddForm from './CommonConfigAddForm'
import CommonConfigEditForm from './CommonConfigEditForm'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [commonConfigId, setCommonConfigId] = useState('')
  const { translate } = useTranslation([
    Namespace.COMMON_CONFIG,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let commonConfig = translate(
      Namespace.COMMON_CONFIG,
      CommonConfigKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: commonConfig
      }
    )

    return {
      commonConfig,
      tabLockedMessage
    }
  }

  function makeCommonConfigForm() {
    if (commonConfigId === '') {
      return (
        <CommonConfigAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setCommonConfigId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <CommonConfigEditForm
          showNotification={showNotification}
          id={commonConfigId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <CommonConfigViewForm
              showNotification={showNotification}
              id={commonConfigId}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.commonConfig,
              tabContent: makeCommonConfigForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage